export function browserMediaUrl(value) {
  if (!value || typeof value !== "string" || typeof window === "undefined") return value || "";
  try {
    const parsed = new URL(value, window.location.origin);
    const managed = parsed.pathname.startsWith("/api/media/");
    const dayoneHost = parsed.hostname.replace(/^www\./, "") === window.location.hostname.replace(/^www\./, "");
    if (managed && dayoneHost) {
      // The public reverse proxy treats URLs ending in .webp as static assets
      // before they reach the API. New managed-media URLs are extensionless;
      // normalizing legacy values here keeps existing uploads visible too.
      const pathname = parsed.pathname.toLowerCase().endsWith(".webp")
        ? parsed.pathname.slice(0, -5)
        : parsed.pathname;
      return `${pathname}${parsed.search}${parsed.hash}`;
    }
  } catch (_) {
    return value;
  }
  return value;
}

export function preloadImage(value, timeoutMs = 15000) {
  const source = browserMediaUrl(value);
  return new Promise((resolve, reject) => {
    const image = new Image();
    const timeout = window.setTimeout(() => reject(new Error("image-timeout")), timeoutMs);
    const finish = (callback) => {
      window.clearTimeout(timeout);
      image.onload = null;
      image.onerror = null;
      callback(source);
    };
    image.onload = () => finish(resolve);
    image.onerror = () => finish(() => reject(new Error("image-unavailable")));
    image.src = source;
  });
}
